import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/Landing';
import ContactPage from '../pages/Contact';
import PortfolioPage from '../pages/Portfolio';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/landing" element={<LandingPage />} />
    <Route path="/contact" element={<ContactPage />} />
    <Route path="/portfolio" element={<PortfolioPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
